module.exports = __webpack_public_path__ + "images/emoji/musical_keyboard.03767c8e4cc1a89432d0.png";